import { ReactElement, forwardRef, Ref } from 'react';
import { useTranslation } from 'react-i18next';

import TextInput, { IInputProps } from '../TextInput';

// NOTE: make sure to use "novalidate" attribute on the "form" element to disable default browser validation

const validRegex =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export function emailValidation(email: string) {
  // local-part should not be longer than 64 characters
  // https://www.rfc-editor.org/info/rfc5321/#section-4.5.3.1.1
  if (email.split('@')[0].length > 64) return false;

  return new RegExp(validRegex).test(email);
}

export type IProps = IInputProps;

function EmailInput(
  { placeholder, message, validation, ...props }: IProps,
  ref: Ref<TextInput>
): ReactElement {
  const { t } = useTranslation();

  return (
    <TextInput
      {...props}
      ref={ref}
      type="email"
      placeholder={placeholder || t('EmailInput.placeholder')}
      validation={validation || emailValidation}
      message={message || t('EmailInput.warningMessage')}
    />
  );
}

export default forwardRef(EmailInput);
